import { InformationCard } from '../../shared/models/card.type';

export const infoCards: InformationCard[] = [
  {
    title: 'Start Your Journey.',
    description: 'It\'s easy to start your Digital Asset learning journey with AmiLearn. As a Morningstar subscriber, join for free to access a starter pack of resources, current news stories, sample lesson briefs, and shared stories from our expert community.',
    image: {
      url: '/assets/imgs/what-you-get/landing-page-1-start-your-journey_x2.png',
      alt: 'A wealth advisor, now the adult student, wears a blue backpack in preparation to start their learning journey with AmiLearn.',
      title: 'Get started with AmiLearn\'s free pack of resources including news stories, suggested books and sample lessons',
      width: '400'
    },
    a11yImages: [
      { type: 'image/webp', srcset: '/assets/imgs/what-you-get/landing-page-1-start-your-journey_x2.webp'},
      { type: 'image/png', srcset: '/assets/imgs/box-nav/what-you-get/landing-page-1-start-your-journey_x2.png'},
    ],
  },
  {
    title: 'Build Your Foundation.',
    description: 'With an AmiLearn subscription gain a fundamental understanding of this new alternative asset class while building knowledge in blockchain, crypto, tokens, custody, the regulatory landscape and much more.',
    image: {
      url: '/assets/imgs/what-you-get/landing-page-2-get-the-fundamentals_x2.png',
      alt: 'A teacher in blue speaks to the wealth advisor student, demonstrating the building blocks of the digital asset world.',
      title: 'An AmiLearn subscription builds your foundational knowledge in the new digital asset landscape.',
      width: '400'
    },
    a11yImages: [
      { type: 'image/webp', srcset: '/assets/imgs/what-you-get/landing-page-2-get-the-fundamentals_x2.webp'},
      { type: 'image/png', srcset: '/assets/imgs/box-nav/what-you-get/landing-page-2-get-the-fundamentals_x2.png'},
    ],
  },
  {
    title: 'Expand your Knowledge.',
    description: 'AmiLearn supports you, the Wealth Advisor, in your learning journey, as you build proficiency to support your clients in this space. <br><br>Stay current on emerging Digital Asset trends and be the Advisor of choice for the evolving investor.',
    image: {
      url: '/assets/imgs/what-you-get/landing-page-3-expand-your-knowledge_x2.png',
      alt: 'Our wealth advisor stands confidently in front of the many roads now open to them, their vision far-seeing to detect the checkpoints and pitfalls in the digital asset world.',
      title: 'Stay current on your learning journey to support your clients and become an advisor of choice.',
      width: '400'
    },
    a11yImages: [
      { type: 'image/webp', srcset: '/assets/imgs/what-you-get/landing-page-3-expand-your-knowledge_x2.webp'},
      { type: 'image/png', srcset: '/assets/imgs/box-nav/what-you-get/landing-page-3-expand-your-knowledge_x2.png'},
    ],
  },
];
